import { render, staticRenderFns } from "./tableHasilTes.vue?vue&type=template&id=483bf7ce&scoped=true"
import script from "./tableHasilTes.vue?vue&type=script&lang=js"
export * from "./tableHasilTes.vue?vue&type=script&lang=js"
import style0 from "./tableHasilTes.vue?vue&type=style&index=0&id=483bf7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483bf7ce",
  null
  
)

export default component.exports